import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function AppFooter({ tone = "light" }) {
  const { t } = useI18n();
  const dark = tone === "dark";
  return (
    <footer
      data-testid="app-footer"
      className={`mt-12 pt-6 pb-4 border-t ${dark ? "border-white/10 text-slate-400" : "border-slate-200 text-slate-500"} text-xs`}
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          © {new Date().getFullYear()} ALLES GEREGELT ·{" "}
          <span className={dark ? "text-slate-500" : "text-slate-400"}>{t.footer.tag}</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <Link to="/sicherheit" data-testid="footer-security" className={`hover:${dark ? "text-white" : "text-ag-ink"} transition-colors`}>{t.footer.security}</Link>
          <Link to="/datenschutz" data-testid="footer-privacy" className={`hover:${dark ? "text-white" : "text-ag-ink"} transition-colors`}>{t.footer.privacy}</Link>
          <Link to="/impressum" data-testid="footer-imprint" className={`hover:${dark ? "text-white" : "text-ag-ink"} transition-colors`}>{t.footer.imprint}</Link>
        </nav>
      </div>
    </footer>
  );
}
